// src/sections/AufstellungsortSection.jsx
import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function AufstellungsortSection({ selectedAnlageId }) {
  const options = [
    "Wohngebäude",
    "Garage",
    "landw. Gebäude",
    "gewerbl. Halle",
    "Freiland",
    "andere",
  ];

  const [checkedValues, setCheckedValues] = useState([]);

  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/aufstellungsort/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.wohngebaeude) loaded.push("Wohngebäude");
        if (data.garage) loaded.push("Garage");
        if (data.landwirtschaftsgebaeude) loaded.push("landw. Gebäude");
        if (data.gewerblicheHalle) loaded.push("gewerbl. Halle");
        if (data.freiland) loaded.push("Freiland");
        if (data.andere) loaded.push("andere");

        setCheckedValues(loaded);
      })
      .catch(() => {
        setCheckedValues([]);
      });
  }, [selectedAnlageId]);

  const handleSave = async () => {
    const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      wohngebaeude: checked.includes("Wohngebäude"),
      garage: checked.includes("Garage"),
      landwirtschaftsgebaeude: checked.includes("landw. Gebäude"),
      gewerblicheHalle: checked.includes("gewerbl. Halle"),
      freiland: checked.includes("Freiland"),
      andere: checked.includes("andere"),
    };

    try {
      // try load existing
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/aufstellungsort/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/aufstellungsort/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Aufstellungsort wurde aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/aufstellungsort`,
        payload
      );

      showSuccess("Gespeichert", "Aufstellungsort wurde gespeichert");
    }
  };

  return (
        <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3 style={{ marginBottom: 16, color: "#0a0a0a", fontWeight: "700", textTransform: "uppercase", fontSize: "24px" }}>AUFSTELLUNGSORT</h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt, index) => (
          <label key={opt}
            style={{
              display: "flex",
              gap: 8,
              marginLeft: index === 1 ? "12px" : index === 0 ? "-6px" : "0",
              alignItems: "center"
            }}>
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
        bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Aufstellungsort
      </Button>
    </Box>
  );
}